import React from "react";
import {productService} from "../jwt/_services/promotions/productService";

export const productProvider = {
    getOptions,
    getItem,
};

async function getOptions() {
    try {
        const dataFilter = {
            fbDataBase : null,
            item : {
                sivexId: null,
                sivexCode: null,
            }
        }

        const listItems = await productService.getOptions(dataFilter);
        return listItems.data.map((itemData) => {
            const {id, sivexId, sivexCode, title} = itemData
            let show = "[" + sivexId + "]" + " - " + sivexCode + " - " + title;
            return (
                {
                    id: id,
                    value: show,
                    label: <div><label>{show}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id) {
    try {
        const item = await productService.getItem(id);
        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}